/* Mold Labs — product detail interactions
   - gallery thumb → hero swap
   - option pills/swatches → resolve matching variant, update price + hidden id + URL
   - quantity stepper
   Accordions use native <details>; quick-add reuses ml-cart.js. */
(function () {
  var root = document.querySelector('[data-ml-pdp]');

  /* ---- gallery: crossfade hero swap ---- */
  function swapHero(src) {
    var hero = document.getElementById('ml-pdp-hero');
    if (!hero || !src) return;
    if (hero.getAttribute('src') === src) return;
    hero.style.opacity = '0';
    var pre = new Image();
    var done = false;
    var apply = function () {
      if (done) return; done = true;
      hero.src = src;
      requestAnimationFrame(function () { hero.style.opacity = '1'; });
    };
    pre.onload = apply;
    pre.src = src;
    setTimeout(apply, 450); // fallback if load stalls
  }
  function markThumb(btn) {
    document.querySelectorAll('.ml-pdp__thumb').forEach(function (t) { t.classList.remove('is-on'); });
    if (btn) btn.classList.add('is-on');
  }
  document.querySelectorAll('[data-ml-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      swapHero(btn.getAttribute('data-ml-thumb'));
      markThumb(btn);
    });
  });

  /* ---- quantity ---- */
  document.querySelectorAll('[data-ml-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-ml-qtynum]');
      var v = parseInt(input.value, 10) || 1;
      v = Math.max(1, v + parseInt(btn.getAttribute('data-ml-qty'), 10));
      input.value = v;
    });
  });

  /* ---- collapsible rows: smooth open/close (native <details> jumps) ---- */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(.22,1,.36,1)';
    document.querySelectorAll('.ml-pdp__acc .ml-acc').forEach(function (d) {
      var summary = d.querySelector('summary');
      var body = d.querySelector('.ml-acc__body');
      if (!summary || !body) return;

      // Wrap body content in a padding-holding inner div, so the animated
      // element itself has no padding (avoids min-height clamp + end snap).
      var padBottom = parseFloat(getComputedStyle(body).paddingBottom) || 0;
      var inner = document.createElement('div');
      inner.className = 'ml-acc__inner';
      inner.style.paddingBottom = padBottom + 'px';
      inner.style.overflow = 'hidden';          // contain child margins so measurement = final auto height
      while (body.firstChild) inner.appendChild(body.firstChild);
      body.appendChild(inner);
      body.style.paddingBottom = '0px';
      body.style.overflow = 'hidden';

      // Keep the content permanently in flow (d.open stays true) and manage
      // visibility purely via height — native <details> first-open reveal
      // otherwise skips the transition. Track state with a class instead.
      var startOpen = d.hasAttribute('open');
      d.open = true;
      d.classList.toggle('ml-open', startOpen);
      body.style.height = startOpen ? 'auto' : '0px';
      body.style.opacity = startOpen ? '1' : '0';

      var DUR = 340;
      var open = startOpen;
      var runId = 0;
      function slide(next) {
        if (next === open) return;
        open = next;
        d.classList.toggle('ml-open', open);
        var target = inner.getBoundingClientRect().height; // fractional — matches final auto height exactly
        var id = ++runId;
        var finalize = function () {
          if (id !== runId) return;              // superseded by a newer toggle
          body.style.transition = '';
          if (open) { body.style.height = 'auto'; body.style.opacity = ''; }
          else { body.style.height = '0px'; body.style.opacity = '0'; }
        };
        if (reduce) { finalize(); return; }
        var cur = body.getBoundingClientRect().height;   // start from where we are
        body.style.overflow = 'hidden';
        body.style.transition = 'none';
        body.style.height = cur + 'px';
        body.style.opacity = getComputedStyle(body).opacity;
        void body.offsetHeight;                  // commit the start frame
        body.style.transition = 'height ' + DUR + 'ms ' + EASE + ', opacity ' + (DUR - 60) + 'ms ease';
        body.style.height = (open ? target : 0) + 'px';
        body.style.opacity = open ? '1' : '0';
        var onEnd = function (ev) {
          if (ev.propertyName !== 'height') return;
          body.removeEventListener('transitionend', onEnd);
          finalize();
        };
        body.addEventListener('transitionend', onEnd);
        setTimeout(finalize, DUR + 80);          // guarantee the resting state
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        slide(!open);
      });
    });
  })();

  if (!root) return;

  /* ---- variants ---- */
  var variants = [];
  try { variants = JSON.parse(root.getAttribute('data-variants')); } catch (e) {}
  var form = document.getElementById('ml-pdp-form');
  if (!form || !variants.length) return;

  function money(cents) {
    // use the shared formatter from ml-cart.js (shop money_format) when available
    if (window.MLmoney) return window.MLmoney(cents);
    return (cents / 100).toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč';
  }

  function selectedOptions() {
    var opts = [];
    form.querySelectorAll('[data-ml-opt]').forEach(function (input) {
      if (input.checked) opts[parseInt(input.getAttribute('data-ml-opt'), 10) - 1] = input.value;
    });
    return opts;
  }

  function markOn(input) {
    var pos = input.getAttribute('data-ml-opt');
    form.querySelectorAll('[data-ml-opt="' + pos + '"]').forEach(function (i) {
      var wrap = i.closest('.ml-pill, .ml-swatch');
      if (!wrap) return;
      var was = wrap.classList.contains('is-on');
      wrap.classList.toggle('is-on', i.checked);
      if (i.checked && !was) {          // pop animation on the newly selected control
        wrap.classList.remove('ml-anim');
        void wrap.offsetWidth;
        wrap.classList.add('ml-anim');
      }
    });
  }

  function bump(el) {                    // re-triggerable enter animation
    if (!el) return;
    el.classList.remove('ml-bump');
    void el.offsetWidth;
    el.classList.add('ml-bump');
  }

  function setText(el, text) {
    if (el && el.textContent !== text) { el.textContent = text; bump(el); }
  }

  /* ---- stock status (real availability + inventory from Shopify) ---- */
  var stockData = [];
  try { stockData = JSON.parse(root.getAttribute('data-stock') || '[]'); } catch (e) {}
  var stockEl = document.querySelector('[data-ml-stock]');
  function updateStock(match) {
    if (!stockEl || !match) return;
    var info = null;
    for (var i = 0; i < stockData.length; i++) if (stockData[i].id === match.id) info = stockData[i];
    var threshold = parseInt(stockEl.getAttribute('data-threshold'), 10) || 5;
    var qty = (info && info.tracked) ? info.qty : null;
    var text, cls;
    if (!match.available) { text = stockEl.getAttribute('data-out') || 'Vyprodáno'; cls = 'is-out'; }
    else if (qty !== null && qty > 0 && qty <= threshold) { text = stockEl.getAttribute('data-low') || 'Poslední kusy skladem'; cls = 'is-low'; }
    else { text = stockEl.getAttribute('data-in') || 'Skladem'; cls = ''; }
    stockEl.classList.remove('is-out', 'is-low');
    if (cls) stockEl.classList.add(cls);
    setText(stockEl.querySelector('[data-ml-stock-text]'), text);
  }

  /* ---- variant image: sync hero + thumb with the selected variant ---- */
  function syncVariantImage(match) {
    var fi = match.featured_image;
    if (!fi || !fi.src) return;
    var path = fi.src.split('?')[0];
    var target = null;
    document.querySelectorAll('[data-ml-thumb]').forEach(function (t) {
      if (t.getAttribute('data-ml-thumb').split('?')[0] === path) target = t;
    });
    if (target) {
      markThumb(target);
      swapHero(target.getAttribute('data-ml-thumb'));
    } else {
      swapHero(fi.src + (fi.src.indexOf('?') > -1 ? '&' : '?') + 'width=1100');
    }
  }

  function update() {
    var chosen = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (!match) return;
    var idEl = form.querySelector('[data-ml-varid]');
    if (idEl) idEl.value = match.id;
    setText(document.querySelector('[data-ml-price]'), money(match.price));
    setText(document.querySelector('[data-ml-addprice]'), money(match.price));
    var addBtn = document.querySelector('[data-ml-addbtn]');
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.style.opacity = match.available ? '' : '.5';
    }
    updateStock(match);
    syncVariantImage(match);
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url);
    }
  }

  form.querySelectorAll('[data-ml-opt]').forEach(function (input) {
    input.addEventListener('change', function () { markOn(input); update(); });
  });

  /* initial sync (stock text + image reflect the pre-selected variant) */
  (function () {
    var chosen = selectedOptions();
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    if (match) { updateStock(match); syncVariantImage(match); }
  })();
})();
